<template>
  <b-modal
    id="modal-stock-counting-cancelation"
    no-close-on-backdrop
    hide-header-close
    hide-footer
    size="md"
    centered
  >
    <template #modal-title>
      <p class="h4">
        {{ $t('Cancelar Contagem') }}
      </p>
    </template>

    <FormulateForm
      ref="cancelationForm"
      name="cancelationForm"
    >
      <b-container>
        <b-row align-h="center">
          <b-col
            md="12"
            class="d-flex flex-column"
          >
            <FormulateInput
              id="cancelation_modal-reason"
              v-model="form.cancelationReason"
              name="reason"
              class="w-100 required"
              type="textarea"
              validation="required"
              rows="4"
              :label="$t('Motivo do cancelamento da contagem')"
            />
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col
            class="d-flex justify-content-end"
            style="gap: 10px"
          >
            <e-button
              :text="$t('Voltar')"
              :text-shortcuts="['ESC']"
              variant="danger"
              @click="onHideModal"
            />
            <e-button
              variant="primary"
              type="submit"
              :busy="busy"
              :text="$t('Confirmar')"
              @click="onConfirm"
            />
          </b-col>
        </b-row>
      </b-container>
    </FormulateForm>
  </b-modal>
</template>

<script>
import { BModal, BContainer, BRow, BCol } from 'bootstrap-vue'
import EButton from '@/views/components/EButton.vue'
import { formulateHelper } from '@/mixins'
import { mapActions } from 'vuex'

export default {
  components: { BModal, BContainer, BRow, BCol, EButton },

  mixins: [formulateHelper],

  data() {
    return {
      busy: false,
      form: {
        id: null,
        cancelationReason: '',
      },
    }
  },

  methods: {
    ...mapActions('pages/stock/stockCounting/stockCountingMaintain', ['cancelCounting']),

    async onConfirm() {
      try {
        this.$refs.cancelationForm.showErrors()
        if (this.$refs.cancelationForm.hasErrors) {
          this.showInvalidDataMessage()
          return
        }
        this.busy = true
        await this.cancelCounting(this.form.cancelationReason)
        this.showSuccess({ message: this.$t('Cancelado com sucesso.') })
        this.$emit('after-confirm')
        this.onHideModal()
      } catch (error) {
        this.showError({ error })
      } finally {
        this.busy = false
      }
    },

    resetForm() {
      this.form = {
        id: null,
        cancelationReason: '',
      }
    },

    onHideModal() {
      this.$bvModal.hide('modal-stock-counting-cancelation')
    },

    show(id) {
      this.$bvModal.show('modal-stock-counting-cancelation')
      this.resetForm()
      this.form.id = id
      this.onFocusInput()
    },

    onFocusInput() {
      setTimeout(() => {
        this.focusInput('#cancelation_modal-reason')
      }, 400)
    },
  },
}
</script>

<style lang="scss" scoped></style>
